(function () {
  'use strict';

  if (window.__smokeysCartAddGuardsInstalled) return;
  window.__smokeysCartAddGuardsInstalled = true;

  var nativeFetch = window.fetch.bind(window);

  function isRequestObject(value) {
    return typeof Request !== 'undefined' && value instanceof Request;
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddRequest(url) {
    return typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart/add.js'));
  }

  function getSelectedStoreId() {
    try {
      return localStorage.getItem('selectedStoreId');
    } catch (e) {
      return null;
    }
  }

  function getHeaderValue(headers, name) {
    if (!headers) return '';
    if (typeof headers.get === 'function') {
      return headers.get(name) || headers.get(name.toLowerCase()) || '';
    }
    return headers[name] || headers[name.toLowerCase()] || '';
  }

  function setQuantityOnPayload(payload, contentType, quantity) {
    if (payload == null) return payload;

    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      payload.set('quantity', String(quantity));
      return payload;
    }

    if (typeof URLSearchParams !== 'undefined' && payload instanceof URLSearchParams) {
      payload.set('quantity', String(quantity));
      return payload;
    }

    if (typeof payload === 'string') {
      if (!contentType || !contentType.includes('json')) {
        var params = new URLSearchParams(payload);
        params.set('quantity', String(quantity));
        return params.toString();
      }

      try {
        var parsed = JSON.parse(payload);
        return JSON.stringify(setQuantityOnPayload(parsed, contentType, quantity));
      } catch (e) {
        return payload;
      }
    }

    if (payload && typeof payload === 'object') {
      var nextPayload = Array.isArray(payload) ? payload.slice() : Object.assign({}, payload);

      if (Array.isArray(nextPayload.items)) {
        nextPayload.items = nextPayload.items.map(function (item) {
          var nextItem = Object.assign({}, item);
          nextItem.quantity = quantity;
          return nextItem;
        });
      } else if (nextPayload.quantity !== undefined) {
        nextPayload.quantity = quantity;
      }

      return nextPayload;
    }

    return payload;
  }

  function reconcileBodyHeaders(init) {
    if (!init || !init.headers) return;

    if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
      init.headers.delete('Content-Type');
    }
  }

  async function buildMutableFetchArgs(input, init) {
    var nextInit = init ? Object.assign({}, init) : {};
    var url = getRequestUrl(input);

    if (!nextInit.headers) {
      nextInit.headers = new Headers(isRequestObject(input) ? input.headers : undefined);
    } else if (!(nextInit.headers instanceof Headers)) {
      nextInit.headers = new Headers(nextInit.headers);
    }

    if (isRequestObject(input)) {
      var request = input;

      [
        'method',
        'credentials',
        'cache',
        'redirect',
        'referrer',
        'referrerPolicy',
        'mode',
        'integrity',
        'keepalive',
        'signal',
      ].forEach(function (key) {
        if (nextInit[key] === undefined && request[key] !== undefined) {
          nextInit[key] = request[key];
        }
      });

      if (!Object.prototype.hasOwnProperty.call(nextInit, 'body') && request.method !== 'GET' && request.method !== 'HEAD') {
        var clonedRequest = request.clone();
        var requestContentType = getHeaderValue(nextInit.headers, 'Content-Type').toLowerCase();

        if (requestContentType.includes('json')) {
          try {
            nextInit.body = await clonedRequest.text();
          } catch (e) {}
        } else if (requestContentType.includes('application/x-www-form-urlencoded')) {
          try {
            nextInit.body = await clonedRequest.text();
          } catch (e) {}
        } else if (requestContentType.includes('multipart/form-data')) {
          try {
            nextInit.body = await clonedRequest.formData();
          } catch (e) {}
        } else {
          try {
            nextInit.body = await clonedRequest.formData();
          } catch (formErr) {
            try {
              nextInit.body = await clonedRequest.text();
            } catch (textErr) {}
          }
        }
      }

      return { input: request.url, init: nextInit, url: url };
    }

    return { input: input, init: nextInit, url: url };
  }

  document.addEventListener(
    'mousedown',
    function (e) {
      var btn = e.target.closest(
        'button[type="submit"], .product-form__submit, button[name="add"], .ocs-card__button, .quick-add__submit'
      );
      if (btn) {
        window.__lastAddBtn = btn;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        var selectedStoreId = getSelectedStoreId();
        if (!selectedStoreId) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof openStoreLocator === 'function') {
            openStoreLocator();
          }
          return false;
        }
      }
    },
    true
  );

  window.getQtyFromContext = function () {
    var node = window.__lastAddBtn || document.activeElement || document.body;
    var card = node.closest?.('.card--product, .product-card, .grid__item, .ocs-card') || document;

    var form = node.closest?.('form') || card.querySelector('form[action*="/cart/add"]');
    var formQtyEl = form?.elements?.quantity;
    if (formQtyEl && !formQtyEl.closest?.('.collection-quantity-selector')) {
      var formQty = parseInt(formQtyEl.value, 10);
      if (Number.isFinite(formQty) && formQty > 0 && formQty <= 99) {
        return formQty;
      }
    }

    var dataQty = parseInt(node?.getAttribute?.('data-quantity'), 10);
    if (Number.isFinite(dataQty) && dataQty > 0 && dataQty <= 99) {
      return dataQty;
    }

    return 1;
  };

  window.fetch = async function (input, init) {
    var requestUrl = getRequestUrl(input);

    if (!isCartAddRequest(requestUrl)) {
      return nativeFetch.call(this, input, init);
    }

    if (!getSelectedStoreId()) {
      if (typeof openStoreLocator === 'function') {
        openStoreLocator();
      }
      return Promise.reject(new Error('Please select a store location first'));
    }

    var btn = window.__lastAddBtn;
    if (btn && btn.closest && btn.closest('.ocs-ajax-add')) {
      return nativeFetch.call(this, input, init);
    }

    var request = await buildMutableFetchArgs(input, init);
    var requestedQty = window.getQtyFromContext ? window.getQtyFromContext() : 1;
    var sendQty = requestedQty;

    try {
      var form = btn?.closest('form');
      var variantId = form?.querySelector('input[name="id"]')?.value;
      var card = btn?.closest('.card--product, .product-card, .grid__item, .ocs-card');
      var invEl = card?.querySelector('.variant-inventory');
      var remaining = null;
      var policy = 'deny';

      if (variantId && invEl) {
        var invMap = JSON.parse(invEl.textContent);
        var meta = invMap[variantId];
        policy = meta?.p || 'deny';
        var onHand = Number.isFinite(meta?.q) ? meta.q : null;

        var cartRes = await nativeFetch('/cart.js');
        var cart = await cartRes.json();
        var inCart = cart.items
          .filter(function (item) {
            return String(item.variant_id) === String(variantId);
          })
          .reduce(function (sum, item) {
            return sum + item.quantity;
          }, 0);

        if (onHand !== null) {
          remaining = Math.max(0, onHand - inCart);
        }
      }

      if (policy === 'deny' && remaining !== null) {
        sendQty = Math.min(requestedQty, remaining);
      }
    } catch (e) {}

    var contentType = getHeaderValue(request.init.headers, 'Content-Type').toLowerCase();
    request.init.body = setQuantityOnPayload(request.init.body, contentType, sendQty);
    reconcileBodyHeaders(request.init);

    return nativeFetch.call(this, request.input, request.init);
  };
})();
